import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-phone-call"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M24.5,15.5c2,0.4,3.6,2,4,4 M24.5,11.5c4.2,0.5,7.5,3.8,8,7.9 M31.4,27.5v3c0,1.1-0.9,2-2,2\n\tc-0.1,0-0.1,0-0.2,0c-3.1-0.3-6-1.4-8.6-3.1c-2.4-1.5-4.5-3.6-6-6c-1.7-2.6-2.7-5.6-3.1-8.7c-0.1-1.1,0.7-2.1,1.8-2.2\n\tc0.1,0,0.1,0,0.2,0h3c1,0,1.9,0.7,2,1.7c0.1,1,0.4,1.9,0.7,2.8c0.3,0.7,0.1,1.6-0.4,2.1l-1.3,1.3c1.4,2.5,3.5,4.6,6,6l1.3-1.3\n\tc0.6-0.5,1.4-0.7,2.1-0.4c0.9,0.3,1.8,0.6,2.8,0.7C30.7,25.6,31.5,26.4,31.4,27.5z",
      class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
    }, null, -1)
  ]), 16))
}
export default { render: render }